<template>
  <div class="modal-custom" v-if="isVisible">
    <div class="modal-custom-content">
      <div class="modal-header">
        <div class="close-container">
          <img
            class="close-button"
            src="/images/close.svg"
            @click="closeModal"
          />
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>


// import '~/assets/scss/components/utils/ModalCustom/ModalCustom.scss';

const props = defineProps({
  isVisible: null,
});

const emit = defineEmits(['close']);

function closeModal() {
  emit('close');
}
</script>


